import { PRODUCT_NAME } from 'src/utils/constants';
import { useEffect } from 'react';
import LiteralsService from 'src/services/literals/LiteralsService';

/**
 * Sets the document title based on the provided string appended to
 * the PRODUCT_NAME constant, in a useLayoutEffect.
 *
 * Resets the title to PRODUCT_NAME when the component is unmounted.
 *
 * @param title A specific page title
 */
export default function useDocumentTitle(title?: string | null | undefined): void {
    useEffect(() => {
        if (title) {
            document.title = PRODUCT_NAME + (title ? ` - ${title}` : '');
        }

        return function cleanup() {
            // Only reset the title if it actually belongs to the hook
            if (document.title.endsWith(` - ${title}`)) document.title = PRODUCT_NAME;
        };
    }, [title]);
}

/** Manually overwrite document title */
export const useDocumentTitleRaw = (title: string): void => {
    useEffect(() => {
        document.title = title;
    }, [title]);
};

/** Prefix document title with 'SpendSmart - ' */
export const useSpendSmartDocumentTitle = (title?: string): void => {
    const prefix = LiteralsService.getLiteral('Budget.titles.app');
    useDocumentTitleRaw(prefix + (title ? ` - ${title}` : ''));
};
